import { Icon, type IconName } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";
import type { ReactNode } from "react";

export interface CompassLikeImageInputEmptyStateProps {
  emptyStateDescription: ReactNode;
  emptyStateIconName?: IconName;
  emptyStateTitle?: ReactNode;
}

export const CompassLikeImageInputEmptyState = ({
  emptyStateDescription,
  emptyStateIconName = "image",
  emptyStateTitle,
}: CompassLikeImageInputEmptyStateProps) => (
  <>
    <div className="bg-secondary group-hover:bg-secondary-hover flex rounded-full p-2 transition-colors duration-200">
      <Icon name={emptyStateIconName} size="md" color="primary" />
    </div>
    <div className="flex min-w-0 flex-col gap-1">
      {emptyStateTitle && (
        <Typography variant="label-sm" color="primary">
          {emptyStateTitle}
        </Typography>
      )}
      <Typography variant="body-sm" color="secondary">
        {emptyStateDescription}
      </Typography>
    </div>
  </>
);
